import { Input, type InputProps } from '@chakra-ui/react';
import { useMask } from '@react-input/mask';
import { forwardRef } from 'react';

const CpfInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, ref) => {
  const inputRef = useMask({
    mask: '___.___.___-__',
    replacement: {
      _: /\d/,
    },
  });

  return <Input {...props} ref={inputRef} type="text" />;
});

export default CpfInput;
